import { BaseResource } from '../core/base-resource';

export class OrderableSpecialDefaultIngredient extends BaseResource {
  choice: string;
  ingredient: string;
}
